import { render, staticRenderFns } from "./ABTests.vue?vue&type=template&id=0c484552&scoped=true&"
import script from "./ABTests.vue?vue&type=script&lang=js&"
export * from "./ABTests.vue?vue&type=script&lang=js&"
import style0 from "./ABTests.vue?vue&type=style&index=0&id=0c484552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c484552",
  null
  
)

export default component.exports